import { AppointmentRow } from "./appointments.defs";
import { Barber } from "../barbers/barber";
import { Inventory } from "../inventory/inventory";
import { Client } from "../clients/client";

export class Appointment {

	id: number;
	cancelled: boolean;
	incomplete: boolean;
	date: Date;
	children: Appointment[] = [];
	created: Date;
	invoiceRef: number;
	forceComplete: boolean;
	anyBarber: boolean;

	constructor(
		private _params: AppointmentRow,
		public service: Inventory,
		public client: Client,
		public barber?: Barber,
	) {
		if (_params) {
			this.load(_params);
		}
	}

	load(p: AppointmentRow) {
		const date = this.date = new Date(p.Appointment);
		date.setSeconds(0,0);

		this.id = p.id;
		this.cancelled = !!(p.cancelled_0);
		this.invoiceRef = p.INVOICERef;
		this.forceComplete = !!(p.noInvoiceComplete);
		this.incomplete = !this.cancelled && !this.invoiced;
		this.created = p.created;
		this.anyBarber = !!(p.any_barber_0);
	}

	get canEdit() {
		return this.id && this.incomplete;
	}

	get invoiced() {
		return this.forceComplete || !!(this.invoiceRef);
	}

	get duration() {
		const c = this.children,
			barber = this.barber ? this.barber.id : 0; // no barber should take default
		return c
			.map(a => a.service.getDuration(barber))
			.reduce((a,b) => a+b, 0) + this.service.getDuration(barber);
	}

	get endDate(): Date {
		const d = new Date(this.date),
			mins = this.duration;
		d.setMinutes(d.getMinutes() + mins);
		return d;
	}

	get services(): Inventory[] {
		return [this.service]
			.concat(this.children
				.map(child => child.service)
			);
	}

	atSameTime(date: Date) {
		const d = new Date(date);
		d.setSeconds(0,0);
		return this.date.getTime() === d.getTime();
	}

	serialize(): AppointmentRow {

		const a: AppointmentRow = {};

		if (this.id) a.id = this.id;
		if (this.cancelled) a.cancelled_0 = true;
		if (this.invoiced) a.INVOICERef = this.invoiceRef;

		if (this.barber) a.BarberRef = this.barber.id;
		if (this.client) a.ClientRef = this.client.id;
		if (this.service) a.SERVICERef = this.service.id;
		
		a.any_barber_0 = this.anyBarber;

		return a;
	}

}